import styled from 'styled-components'

export const InteractionMap = styled.div`
  width: 100%;
  margin: 0.8rem 0;
`
